import {FunctionComponent, useMemo} from "react";
import styles from "./ArrowButton.module.css";

const ArrowButton: FunctionComponent<{disabled: boolean, left?: boolean, callbackFn: Function}> = ({disabled, left, callbackFn}) => {

  const styleObj = useMemo(() => ({
    transform: left ? "rotate(180deg)" : "rotate(0deg)",
    opacity: disabled ? 0.1 : 1,
  }), [disabled, left]);

  return (
    <button
      className={styles.button}
      disabled={disabled}
      onClick={(e) => callbackFn(e)}
    >
      <svg className={styles.svg} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 24">
        <polyline
          className={styles.line}
          points="1 23 17 12 1 1"
          style={styleObj}
        />
      </svg>
    </button>
  );
}

export default ArrowButton;
